<template>
    <div>
        <alarm-list-component :alarm-type="'alarm'"></alarm-list-component>
    </div>
</template>

<script>
import AlarmListComponent from "@/components/alarm/AlarmListComponent";

export default {
    name: "Alarm",
    mixins: [],
    components: {
        AlarmListComponent
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>